import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

const AreaAddition = ({ brands, state, setState }) => {
	// Create rows dynamically based on brands and columns
	const [rowData, setRowData] = useState();
	// Create columns dynamically
	const gridColumns = [
		{ field: "slno", headerName: "ID", width: 70 },
		{ field: "brand", headerName: "Brand", width: 200 },
		{ field: "floor_no", headerName: "Floor", width: 182, editable: true },
		{ field: "carpet_area", headerName: "Carpet Area", width: 200, editable: true },
		{ field: "chargable_area", headerName: "Chargable Area", width: 200, editable: true },
	];

	useEffect(() => {
		const rows = brands.map((brand, index) => {
			const rowData = { slno: index + 1, brand };
			// Fill other columns with default or state values
			gridColumns.forEach((col) => {
				if (col?.field === "slno") rowData[col.field] = index + 1;
				else if (col?.field === "brand") rowData[col.field] = brand;
				else rowData[col.field] = 0;
			});

			// setRows(rowData);
			return rowData;
		});
		setRowData(rows);
	}, [brands]);

	// add area detais to state
	const handleRowUpdate = (data) => {
		let updatedRowData = rowData.map((row) => (row.slno === data.slno ? data : row));
		setRowData(updatedRowData);
		let totalCarpetArea = updatedRowData?.reduce((acc, item) => acc + Number(item.carpet_area), 0);
		let totalCapexValue = state.capex_per_sq_feet * totalCarpetArea;
		let totalChargableArea = updatedRowData?.reduce((acc, item) => acc + Number(item.chargable_area), 0);

		setState({
			...state,
			total_carpet_area: totalCarpetArea,
			total_chargable_area: totalChargableArea,
			total_capex_value: totalCapexValue,
			area_details: updatedRowData,
		});
		console.log("sdfghjklkjhgf", rowData);
		return data;
	};

	return (
		<Box mt={2}>
			<Typography variant="button" width="100%">
				Brandwise Area
			</Typography>
			<Box sx={{ display: "flex", width: "100%" }}>
				<DataGrid
					sx={{
						width: "100%",
						border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[300],
						},
					}}
					columnHeaderHeight={35}
					rowHeight={40}
					rows={rowData}
					getRowId={(row) => row.slno}
					columns={gridColumns}
					disableSelectionOnClick
					hideFooter
					processRowUpdate={(updatedRow, originalRow) => handleRowUpdate(updatedRow)}
				/>
			</Box>
		</Box>
	);
};

export default AreaAddition;
